<script setup lang="ts">
defineProps<{ name: 'ledger' | 'link' | 'send' | 'inbox' | 'clock' | 'check' | 'plus' | 'receipt' }>()
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    class="block shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="butt"
    stroke-linejoin="miter"
  >
    <g v-if="name === 'ledger'">
      <path d="M3.5 2.5h8.5v11H3.5z" />
      <path d="M6 5.5h4M6 8.5h4" />
    </g>
    <g v-else-if="name === 'link'">
      <path d="M6.5 9.5 9.5 6.5" />
      <path d="M7 4.6 8.2 3.4a2.6 2.6 0 0 1 3.7 3.7L10.7 8.3" />
      <path d="M9 11.4 7.8 12.6a2.6 2.6 0 0 1-3.7-3.7L5.3 7.7" />
    </g>
    <g v-else-if="name === 'send'">
      <path d="M2.5 8h10" />
      <path d="M8.5 4l4 4-4 4" />
    </g>
    <g v-else-if="name === 'inbox'">
      <path d="M2.4 9.2 4 3.4h8l1.6 5.8v3.8H2.4z" />
      <path d="M2.4 9.2h3.4l.8 1.6h2.8l.8-1.6h3.4" />
    </g>
    <g v-else-if="name === 'clock'">
      <circle cx="8" cy="8" r="5.4" />
      <path d="M8 4.8V8l2.2 1.4" />
    </g>
    <g v-else-if="name === 'check'">
      <path d="M3 8.4 6.5 12 13 4.6" />
    </g>
    <g v-else-if="name === 'plus'">
      <path d="M8 3v10M3 8h10" />
    </g>
    <g v-else>
      <path d="M3.5 2h9v12l-1.8-1.2L8.9 14 7.1 12.8 5.3 14l-1.8-1.2z" />
      <path d="M6 5.5h4M6 8.5h4" />
    </g>
  </svg>
</template>
